export const manualDocumentEn = {
  // duplicate-document-number dialog (existing)
  document_number_already_exists: `Document number already exists`,
  document_number_exists_message: `A document has already been assigned this document number:{{documentNumber}}`,
  would_you_like_to_generate_new_document_number: `Would you like to generate a new document number`,
  regenerate_document_number: `Regenerate document number`,
  document_number_regenerated_successfully: `Document number regenerated successfully`,

  // section headings
  verifactu_simplified_invoice: `Verifactu simplified invoice`,
  sii_simplified_invoice: `SII simplified invoice`,
  verifactu_regular_invoice: `Verifactu regular invoice`,
  sii_regular_invoice: `SII regular invoice`,
  verifactu_debit_note: `Verifactu debit note`,
  sii_credit_note: `SII credit note`,
  verifactu_credit_note: `Verifactu credit note`,
  sii_corrective_invoice: `SII corrective invoice`,
  verifactu_corrective_invoice: `Verifactu corrective invoice`,
  sdi_regular_invoice: `SDI regular invoice`,
  corrective_invoice: `Corrective invoice`,
  sdi_credit_note: `SDI credit note`,
  replacement_invoice: `Replacement invoice`,
  purchase_order: `Purchase order`,
  delivery_note: `Delivery note`,
  document_information: `Document information`,
  customer_information: `Customer information`,
  vendor_information: `Vendor information`,
  items_information: `Items information`,
  taxes_information: `Taxes information`,
  discounts_information: `Discounts information`,
  recurring_invoice: `Recurring invoice`,
  recurring_invoice_information: `Recurring invoice information`,
  upload_document: `Upload document`,
  "attach_support_document_(optional)": `Attach support document (optional)`,

  // document info fields
  account_class: `Account class`,
  document_class: `Document class`,
  documentNumber: `Document number`,
  documentDate: `Document date`,
  poNumber: `PO number`,
  deliveryNote: `Delivery Note`,
  dueDate: `Due date`,
  ExpenseCategory: `Expense category`,
  comments: `Comments`,
  rectificationReason: `Rectification reason`,
  SpainCorrectionCode: `Correction code`,

  // company / contact (shared between customer & vendor)
  companyName: `Company Name`,
  companyID: `Company ID`,
  companyEmail: `Email`,
  companyAddress: `Company address`,
  email_address: `Email Address`,
  logo_url: `Logo URL`,
  Currency: `Currency`,

  // customer address breakdown
  CustomerCompanyStreet: `Company Street`,
  CustomerCompanyStreetNumber: `Company Street Number`,
  CustomerCompanyLocality: `Company Locality`,
  CustomerCompanyRegion: `Company Region`,
  CustomerCompanyZipCode: `Company Zip Code`,
  CustomerCountry: `Country`,
  customerCompanyStreet_is_missing: `Customer company street is missing`,
  customerCompanyStreetNumber_is_missing: `Customer company street number is missing`,
  customerCompanyLocality_is_missing: `Customer company locality is missing`,
  customerCompanyRegion_is_missing: `Customer company region is missing`,
  customerCompanyZipCode_is_missing: `Customer company zip code is missing`,

  // vendor address breakdown
  VendorCompanyStreet: `Company Street`,
  VendorCompanyStreetNumber: `Company Street Number`,
  VendorCompanyLocality: `Company Locality`,
  VendorCompanyRegion: `Company Region`,
  VendorCompanyZipCode: `Company Zip Code`,
  VendorCountry: `Country`,

  // buttons / status
  submit: `Submit`,
  submit_and_create_new_document: `Submit and create new document`,
  configuration: `Configuration`,
  document_created_successfully: `Document created successfully`,

  // stacked layout (new UI)
  create_compliance_standard_document: `Create {{complianceStandard}} {{documentType}}`,
  customize_invoice_sequencing: `Customize invoice sequencing`,
  configure_document_series: `Configure document series`,
  regular_invoice: `Regular Invoice`,
  verifactu: `Verifactu`,
  sdi: `SDI`,
  sii: `SII`,
  logo_url_missing: `Logo URL missing`,
  edit_vendor_information: `Edit vendor information`,
  fill_vendor_details: `Fill in the vendor details to add them to your list`,
  add_logo_url: `Add logo URL`,
  vendor_address: `Vendor address`,
  vendor_email_address: `Vendor email address`,
  company_street: `Company street`,
  company_street_number: `Company street number`,
  company_locality: `Company locality`,
  company_zip_code: `Company zip code`,
  company_region: `Company region`,
  document_date: `Document date`,
  add_po_number: `Add PO number`,
  po_number: `PO number`,
  add_delivery_note: `Add delivery note`,
  add_pec_code: `Add PEC code`,
  pec_code: `PEC code`,
  pec_code_is_missing: `PEC code is missing`,
  add_destination_code: `Add destination code`,
  destination_code: `Destination code`,
  destination_code_is_missing: `Destination code is missing`,
  invoice_information: `Invoice information`,
  purchase_order_information: `Purchase order information`,
  delivery_note_information: `Delivery note information`,
  purchase_requisition: `Purchase requisition`,
  requester_information: `Requester information`,
  requester_name: `Requester name`,
  company_id: `Company ID`,
  department_dimension_id: `Department`,
  cost_center_dimension_id: `Cost center`,
  request_information: `Request information`,
  priority: `Priority`,
  due_delivery_date: `Due delivery date`,
  requirement_justification: `Requirement justification`,
  ship_to_address: `Ship to address`,
  requesterName_is_required: `Requester name is required`,
  companyId_is_required: `Company ID is required`,
  priority_is_required: `Priority is required`,
  dueDeliveryDate_is_required: `Due delivery date is required`,
  requirementJustification_is_required: `Business justification is required`,
  shipToAddress_is_required: `Ship to address is required`,
  connected_documents: `Connected documents`,
  search_or_add_a_new_customer: `Search or add a new customer`,
  "no_items_added-click_on_add__line_item_to_add_items": `No items added — click on "Add line item" to add items`,
  line_items: `Line items`,
  add_line_item: `Add line item`,
  search_by_reference_code_or_description_or_add_new_item: `Search by reference code or description, or add a new item`,
  search_by_reference_code_description_keywords: `Search by reference code, description, keywords`,
  add_discount: `Add discount`,
  also_add_this_item_to_catalog: `Also add this item to catalog`,
  total_breakdown: `Total breakdown`,
  subtotal: `Subtotal`,
  tax: `Tax`,
  discount: `Discount`,
  wht_tax: `WHT tax`,
  total_amount: `Total amount`,
  additional_options: `Additional options`,
  additional_tax: `Additional tax`,
  support_documents: `Support document`,
  supporting_documents: `Supporting Document`,
  discount_type: `Discount type`,
  amount: `Amount`,
  percentage: `Percentage`,
  base_amount: `Base amount`,
  make_recurring_invoice: `Make recurring invoice`,
  preview_pdf: `Preview PDF`,
  cancel: `Cancel`,
  monthly: `Monthly`,
  yearly: `Yearly`,
  add_item: `Add item`,
  update_item: `Update item`,
  taxes_permission_required: `Taxes permission required`,
  add_tax: `Add Tax`,
  add_new_tax: `Add New Tax`,
  edit_tax: `Edit Tax`,
  rate: `Rate`,
  is_withholding_tax: `Is Withholding Tax`,
  VAT_label: `VAT - Value Added Tax`,
  IGIC_label: `IGIC - Canary Island Tax`,
  IRPF_label: `IRPF - Personal Income Tax`,
  WHT_label: `WHT - Withholding Tax`,
  tax_type_required: `Tax type is required`,
  rate_required: `Rate is required`,
  rate_min: `Rate must be greater than or equal to 0`,
  tax_created_success: `Tax created successfully`,
  tax_updated_success: `Tax updated successfully`,
  error_fetching_tax_data: `Error fetching tax data`,
  update: `Update`,

  // customer edit modal
  edit_customer_information: `Edit customer information`,
  fill_customer_details: `Fill in the customer details to add them to your list`,
  customer_address: `Customer address`,
  customer_company_name: `Customer company name`,
  customer_company_ID: `Customer company ID`,
  customer_email_address: `Customer email address`,
  customerCurrency_is_required: `Customer currency is required`,
  currency: `Currency`,
  delete_customer_title: `Are you sure you want to remove customer?`,
  delete_customer_warning: `Removing the customer wont delete them but remove them from you invoice`,
  delete_vendor_title: `Are you sure you want to remove vendor?`,
  delete_vendor_warning: `Removing the vendor wont delete them but remove them from your invoice`,
  item_delete_title: `Are you sure you want to delete this item?`,
  item_delete_warning: `Deleting the item will remove it from your invoice`,

  // additional options
  item_level_discount_already_added: `An item-level discount is already applied. Disable item discounts before adding a document-level discount.`,

  // document series modal (new UI)
  customize_invoice_sequencing_number: `Customize invoice sequencing number`,
  sequence_number_sub_text: `Create a new invoice sequencing rule, or view existing & previous sequencing rules`,
  add_new_sequencing_rule: `Add new sequencing rule`,
  add_new_sequence_rule_description: `Adding a new sequence rule replaces the currently active rule`,
  add_new_rule: `Add new rule`,
  starting_number: `Starting number`,
  delete_series: `Delete series?`,
  delete_series_warning: `Deleting this series will remove it from your document`,
  deactive_series: `Deactive series`,
  deactivate: `Deactivate`,
  deactivate_sequence_title: `Deactivate this sequence?`,
  deactivate_sequence_note: `Note: You'll need an active sequence to create new invoices.`,
  add_new: `Add New`,
  add_series_warning: `Adding a new series will replace the active one. Continue?`,
  select_or_type_vendor_company_id: `Select vendor company ID`,
  invoicecompliance_module_not_enabled: `Invoice compliance module is not enabled`,
  please_enter_company_name: "Please enter a company name",
  please_select_company_id: "Please select a company ID",
  please_select_country: "Please select a country",
  please_select_currency: "Please select a currency",
  tax_type_is_required: "Tax type is required",
  tax_percentage_is_required: "Tax percentage is required",
  click_to_upload: `Click to upload`,
  no_invoice_number: `No invoice number`,
  created_in_dost_portal_edit_message: `This document was created in Dost Portal, so there's no document to review. Edit it directly`,
  file_size_exceeds: `File size exceeds 5MB`,
  "supported_document.pdf": `supported_document.pdf`,
  delivery_note_required: `Delivery Note is required`,
  poNumber_is_required: `PO Number is required`,
  scheme_id_required: `Scheme ID is required if Participant ID is provided`,
  participant_id_required: `Participant ID is required if Scheme ID is provided`,
  vendor_inbox: `Vendor Inbox`,
  select_peppol_configuration: `Peppol Configuration`,
  customer_inbox: `Customer Inbox`,
  customer_peppol_scheme_id: `Customer Peppol Scheme ID`,
  customer_peppol_participant_id: `Customer Peppol Participant ID`,
  payment_terms: `Payment Terms`,
  payment_terms_is_required: `Payment Terms is required`,
  save_draft_before_leaving: `Save as draft before leaving?`,
  save_as_draft_subtitle: `Your changes haven't been saved. Save them as a draft before leaving?`,
  need_by_date: `Need by date`,
  business_justification: `Business justification`,
  dueDeliveryDate_cannot_be_past: `Due delivery date must be today or a future date`,
  purchase_requisition_required: "Purchase requisition is required.",
  document_number_must_be_empty:
    "Document number is generated automatically and must not be provided.",
  company_id_required: "Company ID is required.",
  department_dimension_id_required: "Department dimension ID is required.",
  purchase_requisition_items_required: "At least one item is required.",
  currency_required: "Currency is required.",
  ship_to_address_required: "Ship to address is required.",
  item_reference_code_required: "Reference Code of the item is mandatory.",
  item_description_required: "Description of the item is mandatory.",
  item_quantity_invalid: "Item '{0}' quantity must be greater than 0.",
  item_unit_price_invalid: "Item '{0}' unit price must be greater than 0.",
  document_number_already_assigned:
    "Document Number '{0}' already exists. Please provide a unique Document Number.",
  cost_center_is_required: `Cost center is required`,
  department_is_required: `Department is required`,
  extra_fields: `Extra fields`,
  erp_field_mappings: `ERP Field Mappings`,
  erp_fields_note: `Configure ERP field mappings for this document`,
  additional_fields: `Additional fields`,
  purchase_order_is_being_processing: `Purchase order is being processed`,
} as const;
